import { IFrameworkResource } from "../../frameworks";
import { ISkillResource } from "../../skills";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ISkillDomainList, ISkillDomainResource } from "../types";

export interface ISkillDomainListQueryParameters extends IPaginateable, IOrderable<"title" | "createdAt"> {
    filters?: {
        title?: string;
        skills?: RelationalFilter<ISkillResource>;
        frameworks?: RelationalFilter<IFrameworkResource>;
        skillDomain?: RelationalFilter<ISkillDomainResource>;
    };
}

export type ISkillDomainListQueryResult = ISkillDomainList;

const mapFilters = (filters: ISkillDomainListQueryParameters["filters"]) => {
    const { title, skills, frameworks, skillDomain } = filters ?? {};
    return {
        title,
        uuid: mapRelationalFilter(skillDomain),
        "skills.uuid": mapRelationalFilter(skills),
        "frameworks.uuid": mapRelationalFilter(frameworks),
    };
};

export const skillDomainListQuery: IApiQueryFunction<ISkillDomainListQueryParameters> = ({
    pagination,
    order,
    filters,
}) => {
    return {
        method: "GET",
        url: `/skill_domains${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useSkillDomainListQuery = createApiQueryHook<ISkillDomainListQueryParameters, ISkillDomainListQueryResult>(
    skillDomainListQuery,
);
